var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1LeftRightArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.37 40H17.66L31 53.37V59L10 38l21-21v5.63L17.65 36h40.72L45 22.63V17l21 21-21 21v-5.63L58.37 40z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Left-right_arrow_C.bea91ad9.svg";
export { SvgJ1LeftRightArrowC as ReactComponent };